import MediaJob from './MediaJob';
import { IMediaJobWithGrouping } from '../interfaces/IMediaJobWithGrouping';

export default class MediaJobWithGrouping extends MediaJob implements IMediaJobWithGrouping
{
  isGroup: boolean;
  reduced: boolean;
}
